import React, { Component } from 'react';
import { Nav, NavItem } from 'react-bootstrap';
import { Redirect } from 'react-router';
import classNames from 'classnames'; 
import firebase from './firebase';
import model from './Model';
import {
  NavReceptionistIcon,
  NavReceptionIcon,
  NavSellerIcon,
  NavStreamerIcon,
 } from './Icon';

export default class ReceptionistNav extends Component {
  constructor(props) {
    super(props);
    this.state = {
      toAgreement: false,
    };
  }

  componentDidMount() {
    model.collection('shops').where('uid', '==', firebase.auth().currentUser.uid).get().then((data) => {
      if (!data.empty) {
        const shop = data.docs[0].data();
        if (!shop.agreementFlag && window.location.pathname !== '/receptionist') {
          this.setState({ toAgreement: true });
          return;
        }
      }
    });
  }

  isNavItemSelected = (itemName) => {
    const path = window.location.pathname;
    if (itemName === "receptionist") {
      return path === "/receptionist";
    }
    if (itemName === "reception") {
      return (
        path.includes("/receptionist/reception")
      );
    }
    return false;
  }

  getNavItemClassName = (itemName) =>
    classNames(
      "navItem",
      this.isNavItemSelected(itemName) && "navItem-selected"
    );

  render() {
    if (this.state.toAgreement) {
      return <Redirect to={{ pathname: "/agreement"}} />;
    }

    return (
      <Nav bsStyle="pills" className="navBar">
        <NavItem href="/receptionist" className={this.getNavItemClassName("receptionist")}>
          <NavReceptionistIcon className="navIcon" />
          <span className="text-center">
            レセプショニスト情報
          </span>
        </NavItem>
        <NavItem href="/receptionist/reception" className={this.getNavItemClassName("reception")}>
          <NavReceptionIcon className="navIcon" />
          <span className="text-center">
            レセプション
          </span>
        </NavItem>
        {this.props.permission.seller && (
          <NavItem href="/" className={this.getNavItemClassName("seller")}>
            <NavSellerIcon className="navIcon navIcon-fill" />
            <span className="text-center">
              TAGsAPI for Sellerへ
            </span>
          </NavItem>
        )}
        <NavItem href="/streamer" className={this.getNavItemClassName("streamer")}>
          <NavStreamerIcon className="navIcon navIcon-fill" />
          <span className="text-center">
            TAGsAPI for Streamerへ
          </span>
        </NavItem>
      </Nav>
    );
  }
}
